import { render } from "./GlPopup.vue?vue&type=template&id=083ae2f0&scoped=true"
import script from "./GlPopup.vue?vue&type=script&lang=js"
export * from "./GlPopup.vue?vue&type=script&lang=js"

import "./GlPopup.vue?vue&type=style&index=0&id=083ae2f0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-083ae2f0"

export default script